import React from 'react';
import { ROUTE_NAMES } from '../../Routes';
import { Helmet } from 'react-helmet-async';
import { Link, useLocation } from 'react-router-dom';

import P_1 from '../../assets/press/Press-1-1.png';
import P_2 from '../../assets/press/Press-2-1.webp';
import P_3 from '../../assets/press/Press-3-1.jpg';
import P_9 from '../../assets/press/1H_41-Foto-3-860x485.jpg';

const pressList = [
	{
		image: P_1,
		title:
			'Starlife: Construction Starts on ’21 Hollywood’ at 2100 N. Federal Highway, Hollywood, FL, 33020',
		link: ROUTE_NAMES.PRESS1,
	},
	{
		image: P_2,
		title:
			'21 Hollywood, a new 13-story mixed-use apartment development is coming to the heart of Hollywood',
		link: ROUTE_NAMES.PRESS2,
	},
	{
		image: P_3,
		title:
			'Exclusive & Iconic: Starlife Group’s 21 Hollywood Recognized as the Best in Luxury Real Estate',
		link: ROUTE_NAMES.PRESS3,
	},
];

export default function PressPage9() {
	const location = useLocation();
	const canonicalUrl = `https://www.thestarlifegroup.com${location.pathname}`;

	return (
		<div className='press-single-page'>
			<Helmet>
				<title>
					First Concrete Poured As Construction Progresses On 21 Hollywood
				</title>
				<meta
					name='description'
					content='Construction momentum continues on 21 Hollywood, the 14-story, luxury mixed-use development from Starlife Group, as crews recently completed the first series of concrete slab pours, marking a key milestone in the foundation phase of the development in Hollywood, Florida.'
				/>
				<meta
					name='keywords'
					content='Starlife press, Real estate news, Luxury property updates, Real estate investment insights, Starlife Group announcements, Property market trends'
				/>
				<link rel='canonical' href={canonicalUrl} />
			</Helmet>
			<div className='col-1'>
				<img src={P_9} alt='press-image' />
				<h2 className='press-page-title'>
					First Concrete Poured As Construction Progresses On 21 Hollywood
				</h2>
				<span className='author-name'>By Lisa Hay</span>
				<span className='author-name'>May 4, 2025</span>
				<Link
					to={
						'https://whatnow.com/miami/real-estate/first-concrete-poured-as-construction-progresses-on-21-hollywood/'
					}
				>
					<span className='author-name'>Source</span>
				</Link>

				<div className='press-page-content'>
					<p>
						Construction momentum continues on 21 Hollywood, the 14-story,
						luxury mixed-use development from Starlife Group, as crews recently
						completed the first series of concrete slab pours, marking a key
						milestone in the foundation phase of the development in Hollywood,
						Florida.
					</p>
					<p>
						Situated on a 1.48-acre site just minutes from the Atlantic Ocean
						and Hollywood’s thriving downtown, the project will feature 200
						luxury rental units and 10,000 square feet of retail space on the
						ground floor. Designed by globally known architect Kobi Karp, 21
						Hollywood offers a world-class living experience defined by
						cutting-edge technology, premium finishes, and breathtaking views.
					</p>
					<p>
						“21 Hollywood embodies our commitment to building thoughtfully
						designed spaces that bring lasting value to residents, investors and
						the South Florida community,” said Gevorg Shahbazyan, CEO & Founder
						of Starlife Group in a statement. “The project is destined to become
						a South Florida landmark that will leave a legacy on the City of
						Hollywood.”
					</p>
					<p>
						Residents will enjoy an array of amenities, including a business
						center with 16-foot ceilings, thoughtfully designed co-working
						spaces, and a private conference room. Health and wellness
						enthusiasts will benefit from a state-of-the-art fitness center with
						14-foot ceilings, complemented by a dedicated yoga and Pilates room.
						Additional offerings include a children’s play area, a dog park with
						a dog spa and wash, dual cinemas and a 85-foot infinity pool that
						serves as the centerpiece of the outdoor experience.
					</p>
					<p>
						Starlife Builders, a subsidiary of Starlife Group, serves as 21
						Hollywood’s general contractor.
					</p>
					<p>
						“Pouring the first slab of 21 Hollywood is a significant milestone
						for the entire team, marking the transition from vision to reality,”
						said Arman Shahbazyan, who leads Starlife Builders and is Co-Founder
						& President of Starlife Group. “As vertical construction progresses,
						each phase will bring us closer to delivering a transformative
						residential experience in the heart of Hollywood.”
					</p>
					<iframe
						title='Google Map Location'
						src='https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3585.0996572486915!2d-80.143687!3d26.0302951!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x88d9abaa6d3f33b9%3A0xc2c60b28d83d4594!2zMjEwMCBOIEZlZGVyYWwgSHd5LCBIb2xseXdvb2QsIEZMIDMzMDIwLCDQodCo0JA!5e0!3m2!1sru!2sam!4v1754313760573!5m2!1sru!2sam'
						width='100%'
						height='400'
						style={{ border: 0 }}
						allowFullScreen=''
						loading='lazy'
						referrerPolicy='no-referrer-when-downgrade'
					></iframe>
				</div>
			</div>
			<div className='col-2'>
				<div className='sticky-press-list'>
					<h3>Press Articles</h3>
					{pressList.map((item, idx) => (
						<Link to={item.link} key={idx}>
							<div className='other-press-card'>
								<img src={item.image} alt={`press-${idx}`} />
								<p>{item.title}</p>
							</div>
						</Link>
					))}
					<Link to={ROUTE_NAMES.PRESS}>
						<button className='view-all-press-btn'>View All</button>
					</Link>
				</div>
			</div>
		</div>
	);
}
